import { OPEN_MESSAGE_BOX, CLOSE_MESSAGE_BOX } from './MessageUser.actions'

const INITIAL_STATE = {
  isMessageBoxOpen: false,
}

export const messageUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OPEN_MESSAGE_BOX:
      return { ...state, isMessageBoxOpen: true }
    case CLOSE_MESSAGE_BOX:
      return { ...state, isMessageBoxOpen: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/messageUser/MessageUser.reducers.js